import {CssBaseline, Grid, Paper} from '@mui/material';
import {Outlet} from 'react-router-dom';

export const HomeLayout = () => {
    return (
        <Grid container component="main" sx={{height: '100vh'}}>
            <CssBaseline />
            <Grid item xs={12} sm={12} md={12} component={Paper} square>
                <div
                    style={{
                        overflowY: 'auto',
                    }}
                >
                    <Outlet />
                </div>
            </Grid>
        </Grid>
    );
};

export default HomeLayout;
